module.exports = __webpack_public_path__ + "img/hr-brown-fluff-06.e7b7c7ef.png";